export default __webpack_public_path__ + "static/media/aicpLOGO.b94e3079.jpg";